import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import FrontPageWrapper from './features/wrapper/components/FrontPageWrapper';
import { createRoot } from 'react-dom/client';
import frontPageReducer from './reducer';

export default function initializeFrontPage(elementOrId: HTMLElement | string): void {
  console.info('loading front page');
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  const store = configureStore({ reducer: frontPageReducer });
  const root = createRoot(element);
  root.render(
    <Provider store={store}>
      <FrontPageWrapper />
    </Provider>
  );
}
